import React from 'react'
import './index.css'
import { useCreateCompletionMutation } from '../../features/openai/openaiSlice'
import { TypeAnimation } from 'react-type-animation'
import ModalBase from '../Modals/ModalBase'

const OpenAI = ({ onDismiss, onAccept, category }) => {

    const [prompt, setPrompt] = React.useState('')
    const [response, setResponse] = React.useState(null)
    const [loading, setLoading] = React.useState(false)

    const [createCompletion] = useCreateCompletionMutation()

    const handlePrompt = async (e) => {
        console.log("Prompt")
        e.preventDefault()
        setLoading(true)
        try {
            const { data } = await createCompletion({ prompt: prompt })
            console.log(data)
            setResponse(data)
        } catch (error) {
            console.log(error)
        }
        console.log(response)
        setLoading(false)
    }
    const cursor = 'custom-type-animation-cursor';

    return (
        <ModalBase
            title={'OpenAI'}
            onClose={onDismiss}
        >
            <div className="chatgpt-popup-wrapper">
                <div className='chatgpt-title'>{category === "Other" ? "Tell us about what you want to post today, and let our AI assistant help draft your listing" : category === "Jobs" ? "Tell us about the position you are looking to fill, and let our AI assistant help draft your listing" : `Describe your apartment for ${category.toLowerCase().replaceAll("for", "")}, and let our AI assistant help draft your listing`}</div>
                <div className="chatgpt-prompt">
                    <input
                        type="text"
                        placeholder={category === "Other" ? "Tell us about what you want to post today" : category === "Jobs" ? "Describe the position you are looking to fill" : "Describe your apartment"}
                        value={prompt}
                        autoFocus={true}
                        onChange={(e) => setPrompt(e.target.value)}
                    />
                    <div className="btn-action" onClick={handlePrompt}>{loading ? 'Loading...' : 'Send'}</div>
                </div>

                {loading &&
                    (
                        <div className='shimmer-wrapper'>
                            <div className='skeleton' style={{ height: '20px', width: '500px' }}></div>
                            <div className='skeleton' style={{ height: '20px', width: '400px' }}></div>
                            <div className='skeleton' style={{ height: '20px', width: '200px' }}></div>
                            <div className='skeleton' style={{ height: '20px', width: '100px' }}></div>
                        </div>
                    )
                }


                {!loading && response && (
                    <div className="chatgpt-popup-title">
                        <TypeAnimation
                            sequence={
                                [
                                    (el) => {
                                        console.log(el);
                                        el.classList.add(cursor)
                                    },
                                    response.replaceAll("</p>", "\n").replaceAll("<p>", "").split("\n").slice(0, -1).join("\n"),
                                    (el) => {

                                        console.log(el);
                                        el.classList.remove(cursor)
                                    },
                                ]}
                            speed={50}
                            className={cursor}
                            cursor={false}
                            style={{ whiteSpace: 'pre-line', overflow: 'auto' }}
                            key={response}
                        />
                    </div>
                )}
                {!loading && response &&
                    (<div className="chatgpt-btn-action">
                        <div className='btn-action' onClick={() => {
                            onAccept(response)
                            onDismiss()
                        }}>Accept</div>
                        <div className='btn-action' onClick={onDismiss}>Dismiss</div>
                    </div>)
                }
            </div>
        </ModalBase >
    )
}

export default OpenAI
